import { useParams } from "react-router";
import MainLayout from "./MainLayout";
import Products from "../services/data/product";
import DetailCard from "./DetailCard";

const DetailLayout = () => {
  const params = useParams();
  const item = Products.filter(
    (Element) => Element.name === params.productName
  );
  console.log(item);
  return (
    <MainLayout>
      <div className="pt-5 mx-auto h-screen">
        <DetailCard item={item[0]} />
      </div>
    </MainLayout>
  );
};

export default DetailLayout;
